var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    { staticClass: "nav-project-mobile" },
    [
      _c("NavItems", {
        attrs: { items: _vm.projectNavItems, "display-type": "icon" }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }